import * as React from 'react'
import { Box } from '@mui/material'
import Control from './Control'

const ButtonControl = ({ boxGrew, WIDTHMIN, ...rest }) => {
  const isLastList = rest.idx === rest.lengthList - 1
  const prps = { isLastList, boxGrew, WIDTHMIN, ...rest }

  return (
    <Box sx={{ alignSelf: 'center' }}>
      {rest.windowWidth > WIDTHMIN ? (
        <Control {...prps} />
      ) : isLastList ? (
        <Control {...prps} />
      ) : null}
    </Box>
  )
}

export default ButtonControl
